import { useCallback } from 'react';
import { Link } from 'react-router-dom';

import { buscarMinhaAssinatura } from '@/api/conta';
import { useRequisicao } from '@/hooks/useRequisicao';
import { formatarDataLonga, formatarMoeda } from '@/lib/formato';

import {
  Carregando,
  Cartao,
  ErroCarregamento,
  EstadoVazio,
  Secao,
  Status,
} from './ContaUI';

const CICLOS = {
  MONTHLY: 'por mês',
  QUARTERLY: 'por trimestre',
  SEMIANNUAL: 'por semestre',
  YEARLY: 'por ano',
};

export default function Assinatura() {
  const buscar = useCallback(buscarMinhaAssinatura, []);
  const { dados, carregando, erro, recarregar } = useRequisicao(buscar);

  if (carregando) {
    return (
      <Secao titulo="Lily Pass">
        <Carregando linhas={1} />
      </Secao>
    );
  }

  if (erro) {
    return (
      <Secao titulo="Lily Pass">
        <ErroCarregamento onTentarNovamente={recarregar} />
      </Secao>
    );
  }

  if (!dados) {
    return (
      <Secao titulo="Lily Pass">
        <EstadoVazio
          titulo="Você ainda não tem o Lily Pass"
          descricao="Com a assinatura você garante presença nos encontros do mês e preços de membro."
          acao={
            <Link
              to="/"
              className="bg-wine hover:bg-wine-deep rounded-full px-5 py-2.5 text-xs font-bold tracking-[0.14em] text-white uppercase transition-colors"
            >
              Conhecer o Lily Pass
            </Link>
          }
        />
      </Secao>
    );
  }

  return (
    <Secao titulo="Lily Pass" descricao="Detalhes da sua assinatura">
      <Cartao>
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-display text-ink text-xl">
              {dados.plan?.name ?? 'Assinatura'}
            </h3>
            {dados.plan && (
              <p className="text-ink-soft mt-1 text-sm">
                {formatarMoeda(dados.plan.price)}{' '}
                {CICLOS[dados.plan.interval] ?? ''}
              </p>
            )}
          </div>
          <Status valor={dados.status} />
        </div>

        <dl className="border-petal mt-5 grid gap-4 border-t pt-5 sm:grid-cols-2">
          <div>
            <dt className="text-ink-soft/50 text-xs tracking-[0.12em] uppercase">
              Início
            </dt>
            <dd className="text-ink-soft mt-1 text-sm">
              {formatarDataLonga(dados.startDate)}
            </dd>
          </div>
          <div>
            <dt className="text-ink-soft/50 text-xs tracking-[0.12em] uppercase">
              Válida até
            </dt>
            <dd className="text-ink-soft mt-1 text-sm">
              {formatarDataLonga(dados.endDate)}
            </dd>
          </div>
        </dl>
      </Cartao>
    </Secao>
  );
}
